import {
    ABOUT_EVENT_NAME,
    CLEAR_EVENT_NAME,
    CLOSE_ALL_TOASTS_EVENT_NAME,
    CONTACT_EVENT_NAME,
    EDUCATION_EVENT_NAME,
    EXPERIENCE_EVENT_NAME,
    HELP_EVENT_NAME,
    PROJECTS_EVENT_NAME,
    SKILLS_EVENT_NAME,
    WELCOME_EVENT_NAME,
} from './events.names';

export const EVENTS = {
    [CLOSE_ALL_TOASTS_EVENT_NAME]: new Event(CLOSE_ALL_TOASTS_EVENT_NAME),
    [ABOUT_EVENT_NAME]: new Event(ABOUT_EVENT_NAME),
    [CONTACT_EVENT_NAME]: new Event(CONTACT_EVENT_NAME),
    [EDUCATION_EVENT_NAME]: new Event(EDUCATION_EVENT_NAME),
    [EXPERIENCE_EVENT_NAME]: new Event(EXPERIENCE_EVENT_NAME),
    [HELP_EVENT_NAME]: new Event(HELP_EVENT_NAME),
    [PROJECTS_EVENT_NAME]: new Event(PROJECTS_EVENT_NAME),
    [SKILLS_EVENT_NAME]: new Event(SKILLS_EVENT_NAME),
    [WELCOME_EVENT_NAME]: new Event(WELCOME_EVENT_NAME),
};
